import { BaseComponent } from '../base-component'
import { $el } from '../../utils/utils'
import { BodyElement } from '../body-element/body-element'

const CONTENT_WRAP_SELECTOR = `[data-accordeon-content-wrap]`
const CONTENT_SELECTOR = `[data-accordeon-content]`
const BODY_ELEMENT_SELECTOR = 'body-element'

export class AccordeonComponent extends BaseComponent {
  resizeObserver: ResizeObserver
  isExpanded: boolean

  mountComponent(): void {
    const content = $el(CONTENT_SELECTOR, this)
    this.isExpanded = this.getAttribute('data-aria-expanded') === 'true'
    this.updateHeight()

    this.addListener(this, 'focusout', this.handleAccordeonFocusout)
    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(content)
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  handleAccordeonFocusout = () => {
    const bodyElement: BodyElement = $el(BODY_ELEMENT_SELECTOR)

    if (!this.isExpanded && bodyElement.isUsingKeyboard) {
      this.show()
    }
  }

  handleResize = (): void => {
    this.updateHeight()
  }

  hide() {
    this.setExpand(false)
    this.emit('hide', { blockId: this.dataset.blockId })
  }

  show() {
    this.setExpand(true)
    this.emit('show', { blockId: this.dataset.blockId })
  }

  toggle() {
    this.setExpand(!this.isExpanded)
    this.emit('toggle', { blockId: this.dataset.blockId })
  }

  updateHeight(): void {
    const contentWrap = $el(CONTENT_WRAP_SELECTOR, this)
    const content = $el(CONTENT_SELECTOR, this)

    if (content) {
      contentWrap.style.maxHeight = `${Math.ceil(
        this.isExpanded ? content.scrollHeight : 0,
      )}px`
    }
  }

  setExpand(isExpanded: boolean) {
    this.isExpanded = isExpanded
    this.setAttribute('data-aria-expanded', isExpanded ? 'true' : 'false')
    this.updateHeight()
  }
}
